module.exports = __webpack_public_path__ + "img/flag-IE.f758ca5b.svg";